<template>
  <el-dialog
    :title="'立即报名'"
    :visible.sync="sginDialag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="700px"
    center
  >
    <div class="edit-list">
      <div class="edit-item">
        <span><b>*</b>机构名称:</span>
        <div class="edit-input">
          <el-input
            disabled
            v-model="company_name"
            placeholder="请输入机构名称"
          ></el-input>
        </div>
      </div>
      <div class="edit-item">
        <span><b>*</b>联系人:</span>
        <div class="edit-input">
          <el-input v-model="tel_name" placeholder="请输入联系人"></el-input>
        </div>
      </div>
      <div class="edit-item">
        <span><b>*</b>联系人电话:</span>
        <div class="edit-input">
          <el-input
            v-model="tel_number"
            placeholder="请输入联系人电话"
          ></el-input>
        </div>
      </div>
      <div v-if="diyForm.length > 0">
        <div class="edit-item" v-for="(item, index) in diyForm" :key="index">
          <span><b v-if="Number(item.state) === 1">*</b>{{ item.name }}:</span>
          <div class="edit-input" v-if="Number(item.type) === 1">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
            ></el-input>
          </div>
          <div class="edit-input" v-if="Number(item.type) === 2">
            <el-input
              v-model="item.value"
              type="textarea"
              :placeholder="'请输入' + item.name"
            ></el-input>
          </div>
          <div class="edit-input active" v-if="Number(item.type) === 3">
            <el-radio-group v-model="diyForm[index].value">
              <el-radio
                v-for="(items, j) in item.option"
                :label="items"
                :key="j"
                >{{ items }}</el-radio
              >
            </el-radio-group>
          </div>

          <div class="edit-input active" v-if="Number(item.type) === 4">
            <el-checkbox-group v-model="diyForm[index].value">
              <el-checkbox
                v-for="(items, j) in item.option"
                :label="items"
                :key="j"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="flex align-center justify-around margin-top">
        <el-button @click="resetForm" class="submit-btn">关闭</el-button>
        <el-button type="primary" @click="submitForm" class="submit-btn"
          >立即报名</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { noticeSignUp2diyForm, noticeSignUpAdd } from '@/api/admin'
export default {
  name: "signupDialog",
  props: {
    sginDialag: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      company_name: '',
      tel_name: '',
      tel_number: '',
      diyForm: [],
      submitState: true
    }
  },
  created () {
    this.company_name = this.$store.state.user.user_name
    this.getForm()
  },
  methods: {
    async submitForm () {
      if (this.submitState) {
        this.submitState = false
      } else {
        return;
      }
      if (!this.company_name) {
        this.$message.error('请输入机构名称')
        this.submitState = true
        return
      }
      if (!this.tel_name) {
        this.$message.error('请输入联系人')
        this.submitState = true
        return
      }
      if (!this.tel_number) {
        this.$message.error('请输入联系人电话')
        this.submitState = true
        return
      }
      const reg = /^1[0-9]{10}$/;
      if (!reg.test(this.tel_number)) {
        this.$message.error('手机号格式错误')
        this.submitState = true
        return
      }
      if (this.diyForm.length > 0) {
        for (let i = 0; i < this.diyForm.length; i++) {
          if (Number(this.diyForm[i].state) === 1) {
            if (Number(this.diyForm[i].type) === 4 && this.diyForm[i].value.length === 0) {
              this.$message.error('请填写' + this.diyForm[i].name)
              this.submitState = true
              return
            }
            if (Number(this.diyForm[i].type) !== 4 && this.diyForm[i].value === '') {
              this.$message.error('请填写' + this.diyForm[i].name)
              this.submitState = true
              return
            }

          }
        }
      }
      let _state = await noticeSignUpAdd(
        this.$route.params.id,
        this.company_name,
        this.tel_name,
        this.tel_number,
        JSON.stringify(this.diyForm),
      )
      if (_state.status === 200) {
        this.$message.success(_state.msg)
        this.$emit('cancelDialog', true)
      }
      this.submitState = true
    },
    resetForm () {
      this.tel_name = ''
      this.tel_number = ''
      this.create_time = ''
      this.signin_time = ''
      this.submitState = true
      this.diyForm.map(item => {
        if (item.type !== 4) {
          item.value = ''
        } else {
          item.value = []
        }
      })
      this.$emit('cancelDialog', false)
    },
    async getForm () {
      let _data = await noticeSignUp2diyForm(this.$route.params.id)
      let _arr = JSON.parse(_data.data.diy_form)
      this.diyForm = _arr.slice(3, _arr.length)
    }
  },
  watch: {
    
  }
}
</script>

<style scoped lang="scss">
.edit-list {
  padding: 20px 0;

  .edit-item {
    display: flex;
    align-items: center;
    line-height: 40px;
    margin-bottom: 10px;

    span {
      display: block;
      width: 150px;
      line-height: 40px;
      text-align: right;
      padding-right: 10px;

      b {
        color: #e4393c;
        margin-right: 5px;
      }
    }

    .edit-input {
      width: 500px;
      min-height: 40px;

      &.active {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        padding: 0 15px;
      }

      &.actives {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        padding: 0 15px;

        div {
          margin-right: 6px;

          i {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.submit-btn {
  width: 200px;
}
</style>